document.addEventListener('scroll', () => {
  const section = document.getElementById('text-scroll-slider');
  const textContainer = document.getElementsByClassName('text-scroll-slider__content');
  const progress = getScrollProgressTextSlider(section);
  const textLines = document.getElementsByClassName('text-scroll-slider__text-line');

  if (textLines) {
    if (progress > 0 && progress < 1) {
      textLines[0].style.opacity = -0.4 + progress * 2;
      textLines[1].style.opacity = -0.5 + progress * 2;
      textLines[2].style.opacity = -0.6 + progress * 2;
      textLines[3].style.opacity = -0.7 + progress * 2;

      textContainer[0].style.display = 'flex';
    } else {
      textLines[0].style.opacity = 0;
      textLines[1].style.opacity = 0;
      textLines[2].style.opacity = 0;
      textLines[3].style.opacity = 0;

      textContainer[0].style.display = 'none';
    }
  }
});

function getScrollProgressTextSlider(element) {
  if (!element) return 0;

  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  const blockTop = rect.top + window.scrollY;
  const blockBottom = blockTop + rect.height;

  const scrollY = window.scrollY;

  if (scrollY <= blockTop - windowHeight) return 0;
  if (scrollY >= blockBottom - windowHeight) return 1;

  return (scrollY - (blockTop - windowHeight)) / (blockBottom - windowHeight - (blockTop - windowHeight));
}
